import { Tour } from 'nextstepjs';
export const showSidebarOnIndexes = [2];
export const getSpotLightTour = (isLargeScreen: boolean): Array<Tour> => [
  {
    tour: 'consoleTour',
    steps: [
      {
        icon: '',
        title: 'Welcome',
        content: "Welcome to the DAWN program. Click 'Next' to get an overview of the site features.",
        side: 'right',
        showControls: true,
        showSkip: true,
      },
      {
        icon: '',
        title: 'Modules',
        content: 'Here you can access the program modules. They will help you learn about mental health management and diabetes.',
        selector: '#modules',
        showControls: true,
        showSkip: true,
        side: 'bottom',
      },
      {
        icon: '',
        title: 'Exercises',
        content:
          'Here you can access the program exercises. They will help you reinforce what you learn from the modules and can be done at any time.',
        selector: isLargeScreen ? '#exercises' : '.c-sidebar #exercises',
        showControls: true,
        showSkip: true,
        side: 'bottom',
      },
      {
        icon: '',
        title: 'Kanzi tool',
        content: 'The Kanzi tool provides helps make webpages accessible. Click this button to hear any content out loud.',
        selector: '.js-kanzi-play-button',
        showControls: true,
        showSkip: true,
        side: 'left',
      },
      {
        icon: '',
        title: 'Kanzi tool',
        content: 'Click this button to translate this website into other languages.',
        selector: '.js-kanzi-translate-button',
        showControls: true,
        showSkip: true,
        side: 'left',
      },
      {
        icon: '',
        title: 'Kanzi tool',
        content: 'Click this button to download any page as a PDF.',
        selector: '.js-kanzi-pdf-button',
        showControls: true,
        showSkip: true,
        side: 'left',
      },
      {
        icon: '',
        title: 'Kanzi tool',
        content: 'Click this button to change how the page looks (e.g., increase font size) or enable dark mode.',
        selector: '.js-kanzi-accessibility-button',
        showControls: true,
        showSkip: true,
        side: 'left',
      },
    ],
  },
];
